import './bootstrap.js';
window.Vue = require('vue').default;
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import Vuetify from 'vuetify';
import es from 'vuetify/es5/locale/es';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueSweetalert2);

import { storeData } from './boot/store.js';
var store = new Vuex.Store(storeData);

import App from './views/App';
import Http from './tools/Http.js';
Vue.prototype.$http = Http;

window.swal = require('sweetalert2'); // added here

const page = (name) => () => import(`./views/${name}.vue`);
const router = new VueRouter({
	mode: 'history',
	routes: [
		{ path: '/', component: page('Welcome'), name: 'welcome' },
		{ path: '/login', component: page('Login'), name: 'login' },

		//Catalogos
		{
			path: '/Catalogo/Usuarios',
			component: page('catalogos/usuarios/Usuarios'),
			name: 'catalogos_usuarios',
		},
		{
			path: '/Catalogo/Bancos',
			component: page('catalogos/bancos/Bancos'),
			name: 'catalogos_bancos',
		},
		{
			path: '/Catalogo/Empleados',
			component: page('catalogos/empleados/Empleados'),
			name: 'catalogos_empleados',
		},
		{
			path: '/Catalogo/Proyectos',
			component: page('catalogos/proyectos/Proyectos'),
			name: 'catalogos_proyectos',
		},
		{
			path: '/Catalogo/Obras',
			component: page('catalogos/obras/Obras'),
			name: 'catalogos_obras',
		},
		{
			path: '/Catalogo/Profesiones',
			component: page('catalogos/profesiones/Profesiones'),
			name: 'catalogos_profesiones',
		},
		{
			path: '/Catalogo/Tipos',
			component: page('catalogos/tipos/Tipos'),
			name: 'catalogos_tipos',
		},
		{
			path: '/Catalogo/Cuadrillas',
			component: page('catalogos/cuadrillas/Cuadrillas'),
			name: 'catalogos_cuadrillas',
		},
		{
			path: '/Catalogo/ConceptosNomina',
			component: page('catalogos/conceptosnomina/ConceptosNomina'),
			name: 'catalogos_conceptosnomina',
		},
		{
			path: '/Catalogo/CuentasBancarias',
			component: page('catalogos/cuentasbancarias/CuentasBancarias'),
			name: 'catalogos_cuentasbancarias',
		},
		{
			path: '/Catalogo/Plantillas',
			component: page('catalogos/plantillas/Plantillas'),
			name: 'catalogos_plantillas',
		},
		// Auxiliares
		{
			path: '/Auxiliares/Percepciones',
			component: page('auxiliares/percepciones/Percepciones'),
			name: 'auxiliares_percepciones',
		},
		{
			path: '/Auxiliares/Deducciones',
			component: page('auxiliares/deducciones/Deducciones'),
			name: 'auxiliares_deducciones',
		},
		{
			path: '/Auxiliares/ISR',
			component: page('auxiliares/ISR/ISR'),
			name: 'auxiliares_ISR',
		},
		{
			path: '/Auxiliares/UMA',
			component: page('auxiliares/UMA/UMA'),
			name: 'auxiliares_UMA',
		},
		{
			path: '/Auxiliares/Subsidios',
			component: page('auxiliares/subsidios/Subsidios'),
			name: 'auxiliares_subsidios',
		},
		{
			path: '/Auxiliares/Incapacidades',
			component: page('auxiliares/incapacidades/Incapacidades'),
			name: 'auxiliares_incapacidades',
		},
		{
			path: '/Auxiliares/Periodos',
			component: page('auxiliares/periodos/Periodos'),
			name: 'auxiliares_periodos',
		},{
			path: '/Auxiliares/ExportadorImss',
			component: page('auxiliares/exportadorTxtImss/ExportadorTxtImss'),
			name: 'auxiliares_generar_txt_imss',
		},
		// Preomina
		{
			path: '/Nomina/Estimaciones',
			component: page('nomina/estimaciones/Estimaciones'),
			name: 'nomina_estimaciones',
		},
		{
			path: '/Nomina/Integrantes',
			component: page('nomina/est_integrantes/Est_Integrantes'),
			name: 'nomina_est_integrantes',
		},
		{
			path: '/Nomina/Estimaciones-Dispersas',
			component: page('nomina/est_dispersas/EstimacionesDispersas'),
			name: 'nomina_dispersadas',
		},
		{
			path: '/Nomina/Administrativa',
			component: page('nomina/administrativa/Administrativa'),
			name: 'nomina_administrativa',
		},
		{
			path: '/Nomina/Calidad',
			component: page('nomina/calidad/Calidad'),
			name: 'nomina_calidad',
		},
		{
			path: '/Nomina/Generar',
			component: page('nomina/generar_prenomina/Acumulado'),
			name: 'nomina_acumulado',
		},
		{
			path: '/Nomina/Piramidacion',
			component: page('nomina/generar_nomina/Piramidacion'),
			name: 'nomina_piramidacion',
		},
		{
			path: '/Nomina/AjusteMensual',
			component: page('nomina/ajuste_mensual/Piramidacion'),
			name: 'nomina_ajuste_mensual',
		},
		{
			path: '/Nomina/MovimientosEmpleados',
			component: page('nomina/movimientos_empleados/Movimientos'),
			name: 'nomina_movimientos_empleados',
		},
		{
			path: '/Nomina/CalcularSDI',
			component: page('nomina/recalculo_sdi/RecalculoSdi'),
			name: 'nomina_recalculo_sdi',
		},
		{
			path: '/Nomina/Extraordinaria',
			component: page('nomina/generar_extraordinaria/Extraordinaria'),
			name: 'nextraordinaria_extraordinaria',
		},
		{
			path: '/Nomina/ExtraordinariaPiramidar',
			component: page('nomina/generar_extraordinaria_nomina/PiramidaExtraordinaria'),
			name: 'nextraordinaria_piramidar',
		},
		// Autorizaciones
		{
			path: '/Autorizacion/AutorizarPrenomina',
			component: page('nomina/autorizacion/autorizar'),
			name: 'nomina_autoriza',
		},
		// Reportes
		{
			path: '/Reportes/NominaAcumulado',
			component: page('reportes/NominaAcumulado'),
			name: 'reportes_nomina_acumulado',
		},
		{
			path: '/Reportes/HistorialEstimaciones',
			component: page('reportes/estimaciones/Estimaciones'),
			name: 'reportes_estimaciones',
		},
		{
			path: '/Reportes/MovimientosEmpleados',
			component: page('reportes/movimientos_empleados/MovimientosEmpleados'),
			name: 'reportes_movimientos',
		},
		{
			path: '/Reportes/NominaActual',
			component: page('reportes/estimaciones_actual/NominaActual'),
			name: 'reportes_nomina_actual',
		},
		{
			path: '/Reportes/Incapacidades',
			component: page('reportes/incapacidades/Incapacidades'),
			name: 'reportes_incapacidades',
		},
		{
			path: '/Reportes/NominaExtraordinaria',
			component: page('reportes/nomina_extraordinaria/NominaExtraordinaria'),
			name: 'reportes_nomina_extraordinaria',
		},
		{
			path: '/Reportes/NominaAdministrativa',
			component: page('reportes/nomina_administrativa/NominaAdministrativa'),
			name: 'reportes_nomina_administrativa',
		},
		{
			path: '/Reportes/NominaProduccion',
			component: page('reportes/nomina_produccion/NominaProduccion'),
			name: 'reportes_nomina_produccion',
		},

		{
			path: '/Reportes/DatosParaGratificacion',
			component: page('reportes/datos_gratificacion/DatosParaGratificacion'),
			name: 'reportes_datos_gratificacion',
		},
	],
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => {
        if (VueRouter.isNavigationFailure(err)) {
            // Ignora el error si es solo una redirección o navegación duplicada
            return err;
        }
        return Promise.reject(err);
    });
};


let authRoutes = ['login', 'logout'];
router.beforeEach((to, from, next) => {
	if (store.state.loading) return;
	// Routes exempted from guard mechanics
	if (authRoutes.includes(to.name)) return next();
	// If there's no token redirect to login
	if (!localStorage.token) return next({ name: 'login' });
	// If authentication hasn't been done try doing so
	if (!store.state.authenticated) {
		store.commit('loading', true);
		store
			.dispatch('authenticate', Vue)
			.then(({ data: { usuario, menu, permissions } }) => {
				store.commit('usuario', usuario);
				store.commit('menu', menu);
				store.commit('permissions', permissions);
				store.commit('loading', false);
				store.commit('authenticated', true);
				store.state.menu.forEach(function(value, key) {
					if (value.isMenu) {
						value.menu.forEach(function(value, key) {
							if (value.route) {
								store.state.routesPermitted.push(value.route.name);
							}
						});
					}
				});

				return next();
			})
			.catch(() => {
				localStorage.removeItem('token');
				store.commit('loading', false);
				router.replace({ name: 'login' });
			});
		return;
	}
	if (store.state.usuario.tipo != 0) {
		if (
			to.name != 'welcome' &&
			!store.state.routesPermitted.includes(to.name)
		) {
			store.dispatch('setSnackbar', {
				text: 'No tiene permiso para esta opción en el sistema',
				type: 'warning',
			});
			return next({ name: 'welcome' });
		}
	}
	next();
});

Vue.mixin({
  data() {
		return {

		}
  },
  methods: {
    removerAcentos: function(str){
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
  }
});

let vuetify = new Vuetify({
	lang: {
		locales: { es },
		current: 'es',
	},
	icons: {
		iconfont: 'mdi',
	},
});

const app = new Vue({
  	render: h => h(App),
	router,
	store,
	vuetify: vuetify,
}).$mount('#app');
